import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './timeline-vertical-mobile-horizontal.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
import * as _ from 'lodash';
var TimelineVerticalMobileHorizontal = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineVerticalMobileHorizontal, _super);
    function TimelineVerticalMobileHorizontal(element) {
        return _super.call(this, element) || this;
    }
    TimelineVerticalMobileHorizontal.prototype.init = function () {
        var _this = this;
        if (this.element.classList.contains('timeline-vertical-mobile-horizontal__json')) {
            //////////////////////////////////////////
            //////////////////////////////////////////
            ////	JSON TIMELINE
            //////////////////////////////////////////
            //////////////////////////////////////////
            if (jsonTimeline) {
                this.filterJson = jsonTimeline;
                this.filterJsonMobile = jsonTimeline;
            }
            // Desktop
            this.filterYearSliderContainer = this.element.querySelector('.js-filter-years');
            this.filterContentSliderContainer = this.element.querySelector('.js-filter-articles');
            if (document.querySelector('.js-reset-timeline-filter')) {
                this.filterButtonReset = document.querySelector('.js-reset-timeline-filter');
            }
            // Mobile
            this.filterYearSliderContainerMobile = this.element.querySelector('.js-filter-years-mobile-container');
            this.filterContentSliderContainerMobile = this.element.querySelector('.js-filter-articles-mobile-container');
            this.createCorrectJson(this.filterJson);
        }
        else {
            //////////////////////////////////////////
            //////////////////////////////////////////
            ////	NORMAL TIMELINE
            //////////////////////////////////////////
            //////////////////////////////////////////
            this.yearsSlider = new Swiper(this.element.querySelector('.timeline-vertical-mobile-horizontal__years'), {
                slidesPerView: 20,
                direction: 'vertical',
                centeredSlides: true,
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: false
            });
            this.contentSlider = new Swiper(this.element.querySelector('.timeline-vertical-mobile-horizontal__content'), {
                slidesPerView: 'auto',
                direction: 'vertical',
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: true,
                mousewheel: {
                    invert: false,
                },
            });
            this.yearsSlider.on('slideChange', function () {
                var yearsSliderContainer = _this.element.querySelector('.timeline-vertical-mobile-horizontal__years');
                if (_this.yearsSlider.realIndex === 0) {
                    yearsSliderContainer.classList.remove('timeline-vertical-mobile-horizontal__years--activated');
                }
                else {
                    yearsSliderContainer.classList.add('timeline-vertical-mobile-horizontal__years--activated');
                }
                _this.contentSlider.slideTo(_this.yearsSlider.realIndex);
            });
            this.contentSlider.on('slideChange', function () {
                var yearsSliderContainer = _this.element.querySelector('.timeline-vertical-mobile-horizontal__years');
                if (_this.yearsSlider.realIndex === 0) {
                    yearsSliderContainer.classList.remove('timeline-vertical-mobile-horizontal__years--activated');
                }
                else {
                    yearsSliderContainer.classList.add('timeline-vertical-mobile-horizontal__years--activated');
                }
                _this.yearsSlider.slideTo(_this.contentSlider.realIndex);
            });
            this.yearsSlides = Array.from(this.element.querySelectorAll('.timeline-vertical-mobile-horizontal__years .swiper-slide'));
            //////////////////////////////////////////
            //////////////////////////////////////////
            ////	MOBILE TIMELINE
            //////////////////////////////////////////
            //////////////////////////////////////////
            this.yearsSliderMobile = new Swiper(this.element.querySelector('.timeline-vertical-mobile-horizontal__mobile--slider__container--years'), {
                slidesPerView: 7,
                direction: 'horizontal',
                centeredSlides: true,
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: false,
            });
            this.contentSliderMobile = new Swiper(this.element.querySelector('.timeline-vertical-mobile-horizontal__mobile--slider__container--content'), {
                slidesPerView: 1.25,
                direction: 'horizontal',
                spaceBetween: 20,
                initialSlide: 0,
                freeMode: true,
                mousewheel: {
                    invert: false,
                },
            });
            this.yearsSliderMobile.on('slideChange', function () {
                _this.contentSliderMobile.slideTo(_this.yearsSliderMobile.realIndex);
            });
            this.contentSliderMobile.on('slideChange', function () {
                _this.yearsSliderMobile.slideTo(_this.contentSliderMobile.realIndex);
            });
            this.yearsSlidesMobile = Array.from(this.element.querySelectorAll('.timeline-vertical-mobile-horizontal__mobile--slider__container--years .swiper-slide'));
            if (document.querySelector('.js-reset-timeline')) {
                this.buttonReset = document.querySelector('.js-reset-timeline');
            }
        }
    };
    TimelineVerticalMobileHorizontal.prototype.bindEvents = function () {
        var _this = this;
        // desktop slider
        if (this.yearsSlider) {
            this.yearsSlides.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var container = element.querySelector('.timeline-vertical-mobile-horizontal__years--year');
                var getIndex = container.getAttribute('data-index');
                _this.contentSlider.slideTo(getIndex - 1);
                _this.yearsSlider.slideTo(getIndex - 1);
            }); });
        }
        // mobile slider
        if (this.yearsSlidesMobile) {
            this.yearsSlidesMobile.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var getIndex = element.getAttribute('data-index');
                _this.contentSliderMobile.slideTo(getIndex - 1);
                _this.yearsSliderMobile.slideTo(getIndex - 1);
            }); });
        }
        // Reset button for Timeline V1
        if (this.buttonReset) {
            this.buttonReset.addEventListener('click', function (event) {
                event.preventDefault();
                if (_this.yearsSlider) {
                    if (_this.yearsSlider.slides) {
                        if (_this.yearsSlider.slides.length > 0) {
                            _this.yearsSlider.slideTo(0);
                        }
                    }
                }
                if (_this.yearsSliderMobile) {
                    if (_this.yearsSliderMobile.slides) {
                        if (_this.yearsSliderMobile.slides.length > 0) {
                            _this.yearsSliderMobile.slideTo(0);
                        }
                    }
                }
            });
        }
        // Reset button for JSON Timeline
        if (this.filterButtonReset) {
            this.filterButtonReset.addEventListener('click', function (event) {
                _this.createCorrectJson(_this.filterJson, 0);
            });
        }
        // check if it has the select option
        if (this.filterOption) {
            this.filterOption.addEventListener('change', function (event) {
                var element = undefined;
                if (event.target) {
                    element = event.target;
                }
            });
        }
    };
    TimelineVerticalMobileHorizontal.prototype.createCorrectJson = function (json) {
        var _this = this;
        var HtmlSelect = "";
        var IndexSelect = 0;
        // create select box
        json.map(function (option) {
            HtmlSelect += "<option value=\"" + IndexSelect + "\">" + option.name + "</option>";
            IndexSelect = IndexSelect + 1;
        });
        this.filterOption = document.querySelector('.js-filter-timeline');
        this.filterOption.innerHTML = HtmlSelect;
        this.filterOption.addEventListener('change', function (event) {
            var element = undefined;
            if (event.target) {
                element = event.target;
            }
            _this.createYearsArticles(_this.filterJson, element.value);
        });
        this.createYearsArticles(this.filterJson, 0);
    };
    TimelineVerticalMobileHorizontal.prototype.createYearsArticles = function (json, option) {
        var _this = this;
        if (option === void 0) { option = undefined; }
        var IndexYear = 0;
        var IndexArticle = 0;
        var DesktopHtmlYears = "";
        var DesktopHtmlArticles = "";
        var DesktopIndex = 0;
        var MobileHtmlYears = "";
        var MobileHtmlArticles = "";
        if (this.filterContentSliderMobile) {
            this.filterContentSliderMobile.destroy();
        }
        if (this.filterYearSliderMobile) {
            this.filterYearSliderMobile.destroy();
        }
        // create years & content
        var selectedOption = parseInt(option);
        var lodashArray = json[selectedOption].items;
        var lodashArrayOrdered = _.orderBy(lodashArray, ['name'], ['desc']);
        lodashArrayOrdered.map(function (year) {
            // html output
            var MobileHeading = false;
            var MobileHeadingHtml = "";
            var DesktopArticles = "";
            var GetArticles = year.articles;
            // Desktop - years
            DesktopHtmlYears += "<div class=\"swiper-slide js-year\" data-hash=\"" + year.name + "\">\n\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__years--year\" data-index=\"" + IndexArticle + "\" data-year=\"" + IndexYear + "\">\n\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__years--year__dot\">\n\t\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__years--year__dot--inner\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__years--year__title\">\n\t\t\t\t\t\t" + year.name + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>";
            // Get articles
            GetArticles.map(function (article) {
                if (!MobileHeading) {
                    MobileHeadingHtml = "<div class=\"timeline-vertical-mobile-horizontal__mobile--slider__container--years__year--text title title--module-title\">\n\t\t\t\t\t\t" + year.name + "\n\t\t\t\t\t</div>";
                    MobileHeading = true;
                }
                else {
                    MobileHeadingHtml = "";
                }
                MobileHtmlYears += "<div class=\"swiper-slide\" data-index=\"" + IndexArticle + "\">\n\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__mobile--slider__container--years__year\">\n\t\t\t\t\t\t" + MobileHeadingHtml + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
                var MobileArticleHeading = "";
                var MobileArticleTitle = "";
                var MobileArticleDescription = "";
                var MobileArticleImage = "";
                if (article.title) {
                    MobileArticleTitle = "<div class=\"timeline-vertical-mobile-horizontal__content--year__content--title\">" + article.title + "</div>";
                }
                if (article.description) {
                    MobileArticleDescription = "<div class=\"timeline-vertical-mobile-horizontal__content--year__content--description\">" + article.description + "</div>";
                }
                if (article.imageDesktop) {
                    MobileArticleImage = "<picture>\n\t\t\t\t\t\t<source srcset=\"" + article.imageDesktop + "\" media=\"(min-width: 1024px)\">\n\t\t\t\t\t\t<source srcset=\"" + article.imageTablet + "\" media=\"(min-width: 768px)\">\n\t\t\t\t\t\t<img class=\"responsive-image \" src=\"" + article.imageMobile + "\" srcset=\"" + article.imageMobile + "\" alt=\"\">\n\t\t\t\t\t</picture>";
                }
                MobileHtmlArticles += "<div class=\"swiper-slide\" data-index=\"{{ loop.index }}\">\t\t\t\n\t\t\t\t\t" + MobileArticleHeading + "\n\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__content--year\">\n\t\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__content--year__content\">\n\t\t\t\t\t\t\t" + MobileArticleTitle + "\n\t\t\t\t\t\t\t" + MobileArticleDescription + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__content--year__image\">\n\t\t\t\t\t\t\t" + MobileArticleImage + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
                DesktopArticles += "<div class=\"timeline-vertical-mobile-horizontal__content--year\" data-year=\"" + IndexYear + "\">\t\t\t\t\t\t\t\n\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__content--year__content\">\t\n\t\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__content--year__content--title\">\t\n\t\t\t\t\t\t\t" + article.title + "\t\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__content--year__content--description\">\t\n\t\t\t\t\t\t\t" + article.description + "\t\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t</div>\t\n\t\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__content--year__image\">\t\n\t\t\t\t\t\t<picture>\t\n\t\t\t\t\t\t\t<source srcset=\"" + article.imageDesktop + "\" media=\"(min-width: 1024px)\">\t\t\t\t\t\t\n\t\t\t\t\t\t\t<source srcset=\"" + article.imageTablet + "\" media=\"(min-width: 768px)\">\t\t\t\t\t\t\n\t\t\t\t\t\t\t<img class=\"responsive-image \" src=\"" + article.imageMobile + "\" srcset=\"" + article.imageMobile + "\" alt=\"\">\t\t\t\t\t\t\n\t\t\t\t\t\t</picture>\t\n\t\t\t\t\t</div>\t\n\t\t\t\t</div>";
            });
            // Desktop - articles
            DesktopHtmlArticles += "<div class=\"swiper-slide\" data-year=\"" + IndexYear + "\">\n\t\t\t\t<div class=\"timeline-vertical-mobile-horizontal__content--heading\">\t\t\t\t\t\t\n\t\t\t\t\t<div class=\"title title--module-title\">\n\t\t\t\t\t\t" + year.name + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t" + DesktopArticles + "\n\t\t\t</div>";
            // GetArticles.map((article: any) => {
            // 	// MOBILE - years
            // 	if(!MobileHeading) {
            // 		MobileHeadingHtml = `<div class="timeline-vertical-mobile-horizontal__mobile--slider__container--years__year--text title title--module-title">
            // 			${year.name}
            // 		</div>`;
            // 		MobileHeading = true;
            // 	}else{
            // 		MobileHeadingHtml = ``;
            // 	}		
            // 	MobileHtmlYears += `<div class="swiper-slide" data-index="${IndexArticle}">
            // 		<div class="timeline-vertical-mobile-horizontal__mobile--slider__container--years__year">
            // 			${MobileHeadingHtml}
            // 		</div>
            // 	</div>`;
            // 	// MOBILE - articles
            // 	let MobileArticleHeading: any = ``;
            // 	let MobileArticleTitle: any = ``;
            // 	let MobileArticleDescription: any = ``;
            // 	let MobileArticleImage: any = ``;
            // 	if(article.title) {
            // 		MobileArticleTitle = `<div class="timeline-vertical-mobile-horizontal__content--year__content--title">${article.title}</div>`;
            // 	}
            // 	if(article.description) {
            // 		MobileArticleDescription = `<div class="timeline-vertical-mobile-horizontal__content--year__content--description">${article.description}</div>`;
            // 	}
            // 	if(article.imageDesktop) {
            // 		MobileArticleImage = `<picture>
            // 			<source srcset="${article.imageDesktop}" media="(min-width: 1024px)">
            // 			<source srcset="${article.imageTablet}" media="(min-width: 768px)">
            // 			<img class="responsive-image " src="${article.imageMobile}" srcset="${article.imageMobile}" alt="">
            // 		</picture>`;
            // 	}
            // 	MobileHtmlArticles += `<div class="swiper-slide" data-index="{{ loop.index }}">			
            // 		${MobileArticleHeading}
            // 		<div class="timeline-vertical-mobile-horizontal__content--year">
            // 			<div class="timeline-vertical-mobile-horizontal__content--year__content">
            // 				${MobileArticleTitle}
            // 				${MobileArticleDescription}
            // 			</div>
            // 			<div class="timeline-vertical-mobile-horizontal__content--year__image">
            // 				${MobileArticleImage}
            // 			</div>
            // 		</div>
            // 	</div>`;
            // 	// DESKTOP - articles
            // 	if(!DesktopHeading) {
            // 		DesktopHtmlArticles += `<div class="swiper-slide" data-year="${IndexYear}">
            // 			<div class="timeline-vertical-mobile-horizontal__content--heading">						
            // 				<div class="title title--module-title">
            // 					${year.name}
            // 				</div>
            // 			</div>
            // 		</div>`;
            // 		DesktopHeading = true;
            // 	}
            // 	DesktopHtmlArticles += `<div class="swiper-slide" data-year="${IndexYear}">
            // 		<div class="timeline-vertical-mobile-horizontal__content--year">							
            // 			<div class="timeline-vertical-mobile-horizontal__content--year__content">	
            // 				<div class="timeline-vertical-mobile-horizontal__content--year__content--title">	
            // 					${article.title}	
            // 				</div>	
            // 				<div class="timeline-vertical-mobile-horizontal__content--year__content--description">	
            // 					${article.description}	
            // 				</div>	
            // 			</div>	
            // 			<div class="timeline-vertical-mobile-horizontal__content--year__image">	
            // 				<picture>	
            // 					<source srcset="${article.imageDesktop}" media="(min-width: 1024px)">						
            // 					<source srcset="${article.imageTablet}" media="(min-width: 768px)">						
            // 					<img class="responsive-image " src="${article.imageMobile}" srcset="${article.imageMobile}" alt="">						
            // 				</picture>	
            // 			</div>	
            // 		</div>
            // 	</div>`;
            // 	IndexArticle++;
            // })
            IndexYear++;
        });
        if (this.filterYearSliderContainer) {
            this.filterYearSliderContainer.innerHTML = DesktopHtmlYears;
            this.filterYearSlider = new Swiper(this.element.querySelector('.timeline-vertical-mobile-horizontal__years--filter'), {
                slidesPerView: 20,
                direction: 'vertical',
                centeredSlides: true,
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: false,
            });
            this.filterYearSlides = Array.from(this.element.querySelectorAll('.timeline-vertical-mobile-horizontal__years--filter .swiper-slide'));
            this.filterYearSlides.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var container = element.querySelector('.timeline-vertical-mobile-horizontal__years--year');
                var getIndex = container.getAttribute('data-index');
                var getIndexYear = container.getAttribute('data-year');
                _this.filterContentSlider.slideTo(getIndexYear);
                _this.filterYearSlider.slideTo(getIndexYear);
            }); });
        }
        if (this.filterContentSliderContainer) {
            this.filterContentSliderContainer.innerHTML = DesktopHtmlArticles;
            this.filterContentSlider = new Swiper(this.element.querySelector('.timeline-vertical-mobile-horizontal__content--filter'), {
                slidesPerView: 'auto',
                direction: 'vertical',
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: true,
                mousewheel: {
                    invert: false,
                }
            });
            this.filterContentSlider.on('slideChangeTransitionEnd', function () {
                var GetActiveDesktopSlider = _this.element.querySelector('.timeline-vertical-mobile-horizontal__content--filter .swiper-slide.swiper-slide-active');
                var GetActiveDesktopSliderYearIndex = GetActiveDesktopSlider.getAttribute('data-year');
                _this.filterYearSlider.slideTo(GetActiveDesktopSliderYearIndex);
            });
        }
        if (this.filterYearSliderContainerMobile) {
            this.filterYearSliderContainerMobile.innerHTML = MobileHtmlYears;
            this.filterYearSliderMobile = new Swiper(this.element.querySelector('.js-filter-years-mobile'), {
                slidesPerView: 7,
                direction: 'horizontal',
                centeredSlides: true,
                spaceBetween: 0,
                initialSlide: 0,
                freeMode: false,
            });
            this.filterYearSliderMobile.on('slideChange', function () {
                _this.filterContentSliderMobile.slideTo(_this.filterYearSliderMobile.realIndex);
            });
            this.filterYearSlidesMobile = Array.from(this.element.querySelectorAll('.js-filter-years-mobile-container .swiper-slide'));
            this.filterYearSlidesMobile.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var getIndex = element.getAttribute('data-index');
                _this.filterContentSliderMobile.slideTo(getIndex);
                _this.filterYearSliderMobile.slideTo(getIndex);
            }); });
        }
        if (this.filterContentSliderContainerMobile) {
            this.filterContentSliderContainerMobile.innerHTML = MobileHtmlArticles;
            this.filterContentSliderMobile = new Swiper(this.element.querySelector('.js-filter-articles-mobile'), {
                slidesPerView: 1.25,
                direction: 'horizontal',
                spaceBetween: 20,
                initialSlide: 0,
                freeMode: true,
                mousewheel: {
                    invert: false,
                },
            });
            this.filterContentSliderMobile.on('slideChange', function () {
                _this.filterYearSliderMobile.slideTo(_this.filterContentSliderMobile.realIndex);
            });
        }
    };
    return TimelineVerticalMobileHorizontal;
}(Base));
export { TimelineVerticalMobileHorizontal };



//////////////////
// WEBPACK FOOTER
// ./components/timeline-vertical-mobile-horizontal/timeline-vertical-mobile-horizontal.component.ts
// module id = 677
// module chunks = 0